import { Component, signal } from '@angular/core';
import { LoadingService } from './core/services/loading.service';
import { GlobalModel } from './core/models/global/GlobalModel.model';

@Component({
  selector: 'app-root',
  standalone: false,
  styleUrl: './app.css',
  templateUrl: './app.html',
})


export class App {

  public static GlobalModel: GlobalModel = new GlobalModel();

  protected readonly title = signal('anameta.one.web');

    loading$;

  constructor(private readonly loadingService: LoadingService) 
  {

    GlobalModel.lang = "tr";
     
    this.loading$ = this.loadingService.loading$;

  }
}

